/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { Resolve, Router } from '@angular/router';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import 'rxjs/add/observable/throw';
import 'rxjs/add/observable/of';

import { LoginConfig } from "./login.config";
import { LoginService } from "./login.service";
import { Subscription } from 'rxjs';

@Injectable()
export class LoginResolver implements Resolve<any> {
    constructor(private loginsvc: LoginService, private router: Router) { }
    resolve(route: ActivatedRouteSnapshot): Subscription {
        return this.loginsvc.OnLoginCallback(route.queryParams).subscribe(
          response => {
            return Observable.of('Login successful.');
          }, 
            error => {
              this.router.navigate([LoginConfig.getFormattedPath(this.loginsvc.app_path, 'loginflow', true)]);
              return Observable.throw('Unable to Login.');
            }
        );
    }
}
